import { render, staticRenderFns } from "./CampaignEditFooter.vue?vue&type=template&id=d7b2c104&"
import script from "./CampaignEditFooter.vue?vue&type=script&lang=ts&"
export * from "./CampaignEditFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports